import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import api from "../../services/api";
import logo from "../../assets/logo.jpeg";

const COLORS = {
  primary: "#0D47A1",
  danger: "#D32F2F",
  bg: "#FFF6EA",
  card: "#FFFFFF",
  border: "#E0E0E0",
  text: "#1E1E1E",
  muted: "#757575",
};

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");

    if (!form.username || !form.password) {
      setError("Username and password required");
      return;
    }

    setLoading(true);

    try {
      const res = await api.post("/auth/login.php", form);

      if (!res.data.success) {
        setError(res.data.message || "Login failed");
        return;
      }

      const user = res.data.user;

      // ✅ DERIVE ROLE FROM NAME
      let role = "SALESMAN"; // default

      if (user.name?.toLowerCase() === "admin") {
        role = "ADMIN";
      }

      const data = {
        token: res.data.token || null,
        user: user,
        role: role, // ✅ IMPORTANT (router depends on this)
      };

      login(data);

      // ✅ NAVIGATION BASED ON ROLE
      if (role === "ADMIN") {
        navigate("/");
      } else {
        navigate("/sales");
      }

    } catch (err) {
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <img src={logo} alt="Company Logo" style={styles.logo} />
        </div>

        <h2 style={styles.title}>Login</h2>
        <p style={styles.subtitle}>
          Enter your credentials to continue
        </p>

        <form onSubmit={submit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Username</label>
            <input
              type="text"
              value={form.username}
              onChange={(e) =>
                setForm({ ...form, username: e.target.value })
              }
              style={styles.input}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) =>
                setForm({ ...form, password: e.target.value })
              }
              style={styles.input}
            />
          </div>

          {error && <p style={styles.error}>{error}</p>}

          <button style={styles.loginBtn} disabled={loading}>
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    background: COLORS.bg,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "100%",
    maxWidth: 420,
    background: COLORS.card,
    borderRadius: 18,
    padding: 40,
    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
  },
  logoWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 15,
  },
  logo: {
    height: 70,
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    textAlign: "center",
  },
  subtitle: {
    textAlign: "center",
    color: COLORS.muted,
    marginBottom: 25,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
  },
  field: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: 5,
  },
  input: {
    padding: 10,
    borderRadius: 8,
    border: `1px solid ${COLORS.border}`,
  },
  loginBtn: {
    marginTop: 10,
    background: COLORS.primary,
    color: "#fff",
    border: "none",
    padding: 12,
    borderRadius: 8,
    cursor: "pointer",
  },
  error: {
    color: COLORS.danger,
  },
};

export default Login;